class BlockIconsColumns {
  constructor() {
    this._init();
  }

  _init() {
    const questions = document.querySelectorAll('.icon-columns__item');

    questions.forEach(function (question) {
      question.addEventListener(
        'click',
        function () {
          question.classList.toggle(
            'active'
          );
        },
        false
      );
    });
  }
}

export const blockIconsColumns = new BlockIconsColumns();
